const colors :any={
    error:"#F96666",
    text:"#474A56",
    grey:"#929AAB",
    primary:"#D3D5FD",
    emphasis: "#0B0B0D",
    disabled: "#AEBDCA",
    white:"#FEFBF6",
}

export  {colors}